module.exports = __webpack_public_path__ + "images/user-placeholder.d1469ecd.png";